// @core/api/endpoints/platform/revoke_federation_peer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RevokeFederationPeerRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Revoke federation peering
 * Permanently disconnects a federation peer. All cached remote data is purged. The remote platform is notified.
 */
export async function RevokeFederationPeer(
  peer_id: string,
  data: RevokeFederationPeerRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id/revoke`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
